<template>
  <div class="wrapper">
    <div class="wrapper_main" v-if="showPage">
      <div class="headerBox">
        <div class="cardLeft">
          <div class="clockBox">
            <img
              class="clockIcon"
              v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundSucTime && orderInfo.refundUpdTime"
              src="../../assets/images/icon_order_unpaid.png"
            />
            <img
              class="clockIcon"
              v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && (orderInfo.refundSucTime || !orderInfo.refundUpdTime)"
              src="../../assets/images/icon_order_complete.png"
            />
            <img
              class="clockIcon"
              v-if="!orderInfo.refundStatus && orderInfo.refundStatus !== 0"
              src="../../assets/images/icon_order_cancel.png"
            />
            <p
              class="clockText"
              v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && orderInfo.refundSucTime"
            >退款成功</p>
            <p
              class="clockText"
              v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundSucTime && orderInfo.refundUpdTime"
            >退款处理中</p>
            <p
              class="clockText"
              v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundUpdTime"
            >退款申请已提交</p>
            <p
              class="clockText"
              v-if="!orderInfo.refundStatus && orderInfo.refundStatus !== 0"
            >{{status | statusText}}</p>
            <p class="clockText" v-if="orderInfo.isFree === 3">(线下支付)</p>
          </div>
          <p class="statusText" v-if="status == '0'">剩余时间 {{expiryTime}}</p>
          <p
            class="statusText"
            v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && orderInfo.refundSucTime"
          >{{orderInfo.refundSucTime | formatTime(10)}}</p>
          <p
            class="statusText"
            v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundSucTime && orderInfo.refundUpdTime"
          >{{orderInfo.refundUpdTime | formatTime(10)}}</p>
          <p
            class="statusText"
            v-if="(orderInfo.refundStatus || orderInfo.refundStatus === 0) && !orderInfo.refundUpdTime"
          >{{orderInfo.refundTime | formatTime(10)}}</p>
          <p
            class="statusText"
            v-if="status != '0' && !orderInfo.refundStatus && orderInfo.refundStatus !== 0"
          >{{status | statusPrompt}}</p>
        </div>
        <img class="order_img" src="../../assets/images/img_order_detail_activity.png" />
      </div>
      <div class="refundBox" v-if="orderInfo.refundStatus || orderInfo.refundStatus === 0">
        <span class="refundText">退款进度</span>
        <div class="refundMainBox">
          <div class="refundMainLeft">
            <div class="circle active_color"></div>
            <div :class="[orderInfo.refundUpdTime?'active_color':'default_color', 'upright']"></div>
            <div :class="[orderInfo.refundUpdTime?'active_color':'default_color', 'circle']"></div>
            <div :class="[orderInfo.refundSucTime?'active_color':'default_color', 'upright']"></div>
            <div :class="[orderInfo.refundSucTime?'active_color':'default_color', 'circle']"></div>
          </div>
          <div class="refundMainRight refundMainRight_succ">
            <span class="refundMainText">退款申请已提交</span>
            <span
              :class="[orderInfo.refundUpdTime?'refund_active':'refund_default', 'refundMainText']"
            >退款处理中</span>
            <span
              :class="[orderInfo.refundSucTime?'refund_active':'refund_default', 'refundMainText']"
            >退款成功</span>
          </div>
        </div>
      </div>
      <div class="mainCard">
        <div
          class="QRCodeCard"
          v-if="(orderInfo.hxType!==1)&&((status == '2' && !orderInfo.refundStatus && orderInfo.refundStatus !== 0) || (status == '5' && !orderInfo.refundStatus && orderInfo.refundStatus !== 0))"
        >
          <span class="QRCodeTitle">活动券码</span>
          <img :src="QRCode" class="QRCode" />
          <span class="QRCodeOrderNo">{{orderInfo.orderNo}}</span>
        </div>
      </div>
      <div class="click_item" @click="goActivityDetail(orderInfo.actId)">
        <img class="click_image" :src="orderInfo.actImgPath" />
        <div class="click_info">
          <span class="click_title ellipsis">{{orderInfo.actTitle}}</span>
          <span
            class="click_time click_desc ellipsis"
          >{{orderInfo.actBegTime | formatTime(4)}} 至 {{orderInfo.actEndTime | formatTime(4)}}</span>
          <span class="click_address click_desc ellipsis">{{orderInfo.actAddress}}</span>
        </div>
      </div>
      <div class="orderCard">
        <p class="orderTitle">报名信息</p>
        <div class="orderNubBox" v-for="(item,index) in activeReg" :key="index">
          <span class="orderNubTitle">{{item.regDicName}}</span>
          <span class="orderNub">{{item.regDicValue}}</span>
        </div>
      </div>
      <div class="orderCard">
        <p class="orderTitle">订单信息</p>
        <div class="orderNubBox">
          <span class="orderNubTitle">下单人</span>
          <span class="orderNub">{{orderInfo.phone}}</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">订单编号</span>
          <span class="orderNub_c">{{orderInfo.orderNo}}</span>
          <span class="copy" @click="copyTradeCode" :data-clipboard-text="orderInfo.orderNo">复制</span>
        </div>
        <div class="orderNubBox">
          <span class="orderNubTitle">下单时间</span>
          <span class="orderNub">{{orderInfo.createTimeCN}}</span>
        </div>
        <div class="orderNubBox" v-if="orderInfo.payTime && status == 2">
          <span class="orderNubTitle">支付时间</span>
          <span class="orderNub">{{orderInfo.payTime | formatTime(11)}}</span>
        </div>
      </div>

      <div class="payAmountBox">
        <span class="label">{{status == 3 || status== 1?'应付金额':'实付金额'}}</span>
        <span class="payAmount">￥{{orderInfo.payAmount|priceFormat}}</span>
      </div>

      <div class="btnBox button" v-if="expiryTime !== '00分00秒' && status == '0'">
        <span class="cancel btn_primary" @click="cancelOrderByOrderId">取消订单</span>
        <span class="btn btn_default" @click="goPayCenter">立即支付</span>
      </div>

      <div class="btnBox button" v-if="isRefund">
        <span class="btn btn_default" @click="getOrderRefundRequest">申请退款</span>
      </div>

      <div
        class="btnBox button"
        v-if="status == 5 && ((orderInfo.hasTemp && !orderInfo.isEvaluate) || (orderInfo.hasTemp && orderInfo.isEvaluate))"
      >
        <span
          class="btn btn_default"
          v-if="orderInfo.hasTemp && !orderInfo.isEvaluate"
          @click="evaluate"
        >去评价</span>
        <span
          class="btn btn_default"
          v-if="orderInfo.hasTemp && orderInfo.isEvaluate"
          @click="viewEvaluation"
        >查看评价</span>
      </div>
    </div>
  </div>
</template>

<script>
import util from '../../utils/util';
import { getUnpaidOrderInfoByOrderId, cancelOrderByOrderId, getOrderRefundRequest, transformToBase64 } from '../../utils/api';
import { mapState } from 'vuex';
import Clipboard from 'clipboard';
import ping from '../../utils/pingpay.js'
var timeout = '';
export default {
  name: 'exchangeOrderDetail',
  props: {},
  filters: {
    statusText: function (value) {
      // 1已取消，3作废
      if (value === 0) {
        return '等待付款';
      } else if (value === 1 || value === 3) {
        return '已取消';
      } else if (value === 2) {
        return '已支付';
      } else {
        return '已结束';
      }
    },
    statusPrompt: function (value) {
      if (value === 1) {
        return '取消原因：用户主动取消';
      } else if (value === 2) {
        return '支付成功，请在活动限期内使用';
      } else if (value === 3) {
        return '取消原因：超时取消';
      } else {
        return '感谢您的参与';
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  unmounted() {
    clearTimeout(timeout);
  },
  data() {
    return {
      title: '活动表单',
      orderNo: '',
      status: '',
      showPage: false,
      orderInfo: {},
      activeReg: '',
      expiryTime: '',
      QRCode: '',
      isRefund: '',
      payAmount: '',
      canPay: true,
      id: ''
    };
  },
  created() {
    // this.id = this.$route.query.id;
    // this.getUnpaidOrderInfoByOrderId()
  },
  activated() {
    this.id = this.$route.query.id;
    this.getUnpaidOrderInfoByOrderId()
    // if (this.id !== this.$route.query.id) {
    //   this.id = this.$route.query.id;
    //   this.getUnpaidOrderInfoByOrderId()
    // }
    // if (this.common.isChange) {
    //   this.$store.commit('isChange', false)
    //   this.getUnpaidOrderInfoByOrderId()
    // }
  },
  methods: {
    viewEvaluation() {
      this.$router.push(`/evaluate/viewEvaluate?id=${this.orderInfo.id}`)
    },
    evaluate() {
      this.$router.push(`/evaluate/evaluate?id=${this.orderInfo.id}&referenceName=${this.orderInfo.actTitle}&templateType=1&referenceNo=${this.orderInfo.orderNo}`)
    },
    goActivityDetail(id) {
       //this.$router.push(`/activityDetails/${id}`)
       var url = `/activityDetails/${id}`;
        if(this.common.cityId){
          url =url +"?cityId="+this.common.cityId
        }else if(this.common.marketInfo.id){
          url =url +"?marketId="+this.common.marketInfo.id
        }
        this.$router.push(url);
    },
    copyTradeCode() {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        util.showToast('复制成功')
        // 释放内存
        clipboard.destroy()
      })
    },
    // 立即支付
    goPayCenter() {
      if (!this.canPay) { return; }
      this.canPay = false;
      let params = {
        orderNo: this.id,
        repairNo: '', // "报修单号",
        bussinessType: "2",//会议室1,活动2,租赁账单3,物业报修4,保洁服务5,送水服务6
        feeCode: this.orderInfo.actId,
        // payType: '5', // "支付类型 0微信，1支付宝, 4万生活, 5,ping++"
        channel: 'wx_pub' // 渠道名
      };
      ping(
        params,
        '',
        res => {
          console.log(res);
          this.canPay = true;
          this.getUnpaidOrderInfoByOrderId()
        },
        () => {
          this.canPay = true;
          this.getUnpaidOrderInfoByOrderId()
        },
        () => {
          this.canPay = true;
          this.getUnpaidOrderInfoByOrderId()
        }
      );
      setTimeout(() => { this.canPay = true; }, 1000)
    },
    goDetail() {
      this.$router.push(`/mall/goodsDetail/${this.details.activeId}`)
    },
    getUnpaidOrderInfoByOrderId() {
      getUnpaidOrderInfoByOrderId({ orderNo: this.id, orderId: '' }).then(res => {
        console.log(res)
        if (!res.res) {
          util.showToast('服务异常');
          return;
        }
        if (res.res.code === 10000 && res.body) {
          this.isRefund = res.body.isRefund
          let date = util.formatTime(new Date(res.body.orderInfo.lastPayTime - Date.parse(new Date())), 3)
          if (res.body.orderInfo && res.body.activeReg) {
            this.orderInfo = res.body.orderInfo;
            this.status = res.body.orderInfo.status;
            this.activeReg = res.body.activeReg;
          } else {
            util.showToast('暂无数据');
          }
          if (this.status === 0) {
            this.leftTimer(date)
          } else if (this.status === 2 || this.status === 5) {
            this.getQRCode()
          }
        } else {
          util.showToast(res.res.msg);
        }
        this.showPage = true;
      })
    },
    leftTimer(leftTime) {
      clearTimeout(timeout)
      var minutes = parseInt(leftTime / 60 % 60, 10); // 计算剩余的分钟
      var seconds = parseInt(leftTime % 60, 10); // 计算剩余的秒数
      var myTime = leftTime
      minutes = this.checkTime(minutes);
      seconds = this.checkTime(seconds);
      if (myTime >= 0) {
        this.expiryTime = minutes + '分' + seconds + '秒';
        myTime = myTime - 1
        timeout = setTimeout(() => {
          this.leftTimer(myTime)
        }, 1000)
      }
    },
    checkTime(i) { // 将0-9的数字前面加上0，例1变为01
      if (i < 10) {
        i = '0' + i;
      }
      return i;
    },
    // 取消订单
    cancelOrderByOrderId() {
      util.showModal('', '确定要取消该订单吗？', true, '确定', () => {
        cancelOrderByOrderId({
          orderId: this.orderInfo.id,
          type: 0
        }, { userId: this.common.userId, openId: this.common.openId }).then(res => {
          if (res.res.code === 10000) {
            this.status = 1
          }
        })
      })
    },
    // 退款
    getOrderRefundRequest() {
      util.showModal('', '确定要退款吗？', true, '确定', () => {
        getOrderRefundRequest({
          orderNo: this.orderInfo.orderNo
        }, { userId: this.common.userId, openId: this.common.openId }).then(res => {
          if (res.res.code === 10000) {
            this.getUnpaidOrderInfoByOrderId();
          } else {
            util.showToast(res.res.msg)
          }
        })
      })
    },
    getQRCode: function () {
      let content = {
        actId: this.orderInfo.actId,
        orderNo: this.orderInfo.orderNo,
        userId: this.orderInfo.userId,
        orderType: 0
      }
      transformToBase64(content).then(res => {
        if (res.res.code === 10000) {
          this.QRCode = res.body['encodeBase64']
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background-color: rgba(243, 244, 246, 1);
}
.wrapper_main {
  margin-bottom: 120px;
}
.headerBox {
  height: 150px;
  background: linear-gradient(
    90deg,
    rgba(23, 64, 218, 1) 0%,
    rgba(101, 0, 255, 1) 100%
  );
  .flex();
  justify-content: space-between;
  align-items: center;
  padding: 0 28px;
  position: relative;
  .order_img {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 280px;
    height: 96px;
    z-index: 2;
  }
}
.cardLeft {
  .flex(column);
  justify-content: space-between;
  align-items: flex-start;
  height: 96px;
}

.clockBox {
  .flex();
  align-items: center;
  height: 36px;
}

.clockIcon {
  width: 36px;
  height: 36px;
  margin-right: 14px;
}

.clockText {
  .fontSize(14px);
  font-weight: bold;
  color: #fff;
}

.statusText {
  height: 36px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  .fontSize(11px);
  color: rgba(255, 255, 255, 1);
  line-height: 36px;
  text-align: center;
  padding: 0 14px;
}
/*item 样式*/
.click_item {
  .flex();
  padding: 28px;
  opacity: 1;
  background-color: #ffffff;
  margin-bottom: 14px;
}
.click_item:active {
  opacity: 0.7;
}
.click_desc {
  .fontSize(12px);
  color: @color6;
  line-height: 34px;
  margin-bottom: 8px;
}
.click_image {
  display: block;
  width: 240px;
  height: 180px;
  margin-right: 20px;
}
.click_info {
  .flex(column);
}
.click_title {
  height: 40px;
  .fontSize(14px);
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  .textOver(434px);
  margin-bottom: 14px;
}
.click_time {
  white-space: nowrap;
}
.click_address {
  line-height: 34px;
  max-height: 68px;
  overflow: hidden;
  width: 434px;
  color: @color6;
  .fontSize(12px);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: pre-line;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
}

/*-----------中间卡片信息模块------*/

.card_box {
  position: relative;
  width: 690px;
  margin-left: 30px;
  margin-top: 26px;
}

.card_title {
  .fontSize(14px);
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(254, 254, 254, 1);
  line-height: 36px;
  position: absolute;
  left: 28px;
  top: 30px;
  right: 28px;
}

.pay_time {
  .fontSize(12px);
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(254, 254, 254, 1);
}

.card_address {
  .fontSize(12px);
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(254, 254, 254, 1);
  position: absolute;
  left: 28px;
  top: 116px;
  right: 28px;
}

.card_price_box {
  flex-direction: row;
  position: absolute;
  left: 28px;
  right: 28px;
  bottom: 124px;
}

.card_price {
  color: #fff;
  .fontSize(18px);
  line-height: 36px;
}

.card_num {
  color: #fff;
  .fontSize(12px);
  line-height: 36px;
  margin-top: 4px;
}

.card_time_box {
  flex-direction: row;
  justify-content: space-between;
  position: absolute;
  height: 102px;
  align-items: center;
  left: 28px;
  right: 28px;
  bottom: 0;
}

.activity_time {
  color: #fff;
  .fontSize(12px);
}

/*----------中间用户信息模块-------*/
.refundBox {
  background-color: rgba(255, 255, 255, 1);
  padding: 28px;
}

.refundText {
  height: 44px;
  .fontSize(16px);
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 44px;
  margin-bottom: 20px;
  padding-left: 18px;
  position: relative;
  &::after {
    position: absolute;
    content: "";
    left: 0;
    top: 4px;
    width: 6px;
    height: 24px;
    background: @color17;
  }
}

.refundMainBox {
  .flex();
  margin-top: 18px;
  width: 710px;
}

.refundMainLeft {
  width: 72px;
  .flex(column);
  justify-content: space-around;
  align-items: center;
}

.refundMainRight {
  flex: 1;
  height: 34px;
  .flex(column);
  justify-content: space-between;
}
.refundMainRight_upt {
  height: 128px;
}
.refundMainRight_succ {
  height: 220px;
}

.refundMainText {
  .fontSize(12px);
  /*color: rgba(51, 51, 51, 1);*/
  line-height: 34px;
}
.refund_active {
  color: #333333;
}
.refund_default {
  color: #dadada;
}

.circle {
  width: 20px;
  height: 20px;
  background-color: @color17;
  border: 4px solid rgba(255, 255, 255, 1);
  border-radius: 100%;
  // margin: 7px 0;
}

.upright {
  width: 4px;
  height: 60px;
  /*background-color: @color17;*/
}
.active_color {
  background-color: @color17;
}
.default_color {
  background-color: #dadada;
}

/*----------中间用户信息模块-------*/

.copy {
  width: 96px;
  height: 40px;
  border-radius: 8px;
  .border();
  .fontSize(12px);
  color: @color3;
  line-height: 40px;
  text-align: center;
  margin-left: 28px;
}

.mainCard {
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  /*box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.02);*/
  /*border-radius: 16px;*/
  margin-bottom: 14px;
}

.QRCodeCard {
  .flex(column);
  align-items: center;
  width: 100%;
}
.QRCodeTitle {
  .fontSize(14px);
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 40px;
}

.QRCode {
  width: 260px;
  height: 260px;
  /*margin: 20px 0;*/
}

.QRCodeOrderNo {
  .fontSize(14px);
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-bottom: 40px;
}

.orderCard {
  padding: 28px;
  margin: 14px 0;
  background-color: #ffffff;
}

.createTimeBox {
  border-top-width: 2px;
  border-top-color: rgba(234, 234, 234, 1);
  padding: 0 20px 28px;
}

.orderTitle {
  height: 28px;
  .fontSize(14px);
  font-weight: bold;
  color: @color3;
  line-height: 28px;
  border-left: 4px solid @color17;
  margin-top: 6px;
  margin-bottom: 20px;
  padding-left: 14px;
}

.orderNubBox {
  min-height: 40px;
  margin-bottom: 14px;
  .flex();
}

.orderNubTitle {
  .fontSize(12px);
  color: @color6;
  line-height: 34px;
  padding-left: 16px;
  width: 150px;
}

.orderNub {
  .fontSize(12px);
  color: @color3;
  line-height: 34px;
  width: 500px;
}
.orderNub_c {
  .fontSize(12px);
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
}

.customer_box {
  padding-top: 20px;
  border-bottom-width: 10px;
  border-bottom-color: #f3f4f6;
}

.customer_box_list {
  flex-direction: row;
  justify-content: space-between;
  border-top-width: 1px;
  border-top-color: #f3f4f6;
  padding-left: 30px;
  padding-right: 30px;
}

.list_key {
  height: 100px;
  line-height: 100px;
  .fontSize(14px);
  color: #999;
}

.list_val {
  height: 100px;
  line-height: 100px;
  .fontSize(14px);
  color: #333;
}

/*----------中间支付选择模块-------*/

.butn_img {
  position: relative;
  top: -1px;
  left: -1px;
}

.payAmountBox {
  background-color: #fff;
  height: 92px;
  line-height: 92px;
  .flex();
  align-items: center;
  justify-content: space-between;
  padding: 0 44px;
  margin: 14px 0;
  /*border-radius: 16px;*/
}

.label {
  .fontSize(13px);
  color: rgba(51, 51, 51, 1);
}

.payAmount {
  .fontSize(13px);
  color: rgba(252, 63, 86, 1);
}

/*-----------底部模块----------*/

.btnBox {
  height: 108px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 33;
  .borderT();
  background-color: #fff;
  .flex();
  align-items: center;
  justify-content: flex-end;
}

.cancel {
  width: 128px;
  height: 52px;
  border-radius: 4px;
  .border(#dadada);
  .fontSize(13px);
  color: #666666;
  line-height: 54px;
  text-align: center;
  margin-right: 28px;
  display: block;
}

.btn {
  width: 128px;
  height: 52px;
  border-radius: 4px;
  .border(@color17);
  .fontSize(13px);
  color: @color17;
  // line-height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-align: center;
  margin-right: 28px;
  background: rgba(243, 245, 253, 1);
  // display:block;
}
</style>
